import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
    styled,
    Fab,
    AppBar,
    Toolbar,
    IconButton,
    Box,
    TextField,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import HomeIcon from '@mui/icons-material/Home';
import ArrowUpIcon from '@mui/icons-material/ArrowUpward';
import SearchIcon from '@mui/icons-material/Search';
import VideogamesIcon from '@mui/icons-material/VideogameAsset';
import FaceIcon from '@mui/icons-material/Face';

const Navbar = () => {
    const StyledFab = styled(Fab)({
        position: 'absolute',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        top: -30,
        left: 0,
        right: 0,
        margin: '0 auto',
    });

    const navigate = useNavigate();
    const [showScrollTop, setShowScrollTop] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const toggleSearch = () => {
        setShowSearch(!showSearch);
        setSearchTerm(''); // Limpar o termo ao fechar
    };

    const handleNavigation = (path) => {
        navigate(path);
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    const handleSearchInputChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleSearchSubmit = (event) => {
        event.preventDefault(); // Evitar o comportamento padrão de submit
        console.log("Navbar - Termo de busca submetido:", searchTerm);
        if (searchTerm.trim()) {
            navigate(`/pesquisar?query=${encodeURIComponent(searchTerm.trim())}`); // ALTERADO PARA /pesquisar
            setShowSearch(false);
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 0) {
                setShowScrollTop(true);
            } else {
                setShowScrollTop(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            <AppBar
                elevation={0}
                position="fixed"
                sx={{
                    top: 'auto',
                    bottom: 0,
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    bgcolor: '#121212'
                }}
            >
                <Toolbar sx={{ minHeight: '64px!important', px: [2] }}>
                    {showSearch ? (
                        <Box
                            component="form"
                            onSubmit={handleSearchSubmit}
                            sx={{
                                alignItems: 'center',
                                display: 'flex',
                                width: '100%'
                            }}
                        >
                            <Box
                                sx={{
                                    alignItems: 'center',
                                    display: 'flex',
                                    width: '100%',
                                }}
                            >
                                <TextField
                                    fullWidth
                                    size='small'
                                    name='search'
                                    placeholder="Pesquisar"
                                    value={searchTerm}
                                    onChange={handleSearchInputChange}
                                    autoFocus={showSearch ? true : false}
                                    sx={{
                                        p: 0,
                                        m: 0,
                                    }}
                                />
                            </Box>
                            <Box flexGrow={1} />
                            <IconButton
                                aria-label="fechar"
                                color="inherit"
                                onClick={toggleSearch}
                                sx={{
                                    ml: 1
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    ) : (
                        <>
                            <Box gap={1} sx={{ alignItems: 'center' }}>
                                <IconButton
                                    color="inherit"
                                    onClick={() => handleNavigation("/cores")}
                                >
                                    <VideogamesIcon />
                                </IconButton>
                            </Box>

                            {showScrollTop ? (
                                <StyledFab
                                    aria-label="voltar ao topo"
                                    onClick={scrollToTop}
                                >
                                    <ArrowUpIcon />
                                </StyledFab>
                            ) : (
                                <Link to="/" style={{ textDecoration: 'none' }}>
                                    <StyledFab
                                        aria-label="jogos"
                                        color="primary"
                                    >
                                        <HomeIcon />
                                    </StyledFab>
                                </Link>
                            )}

                            <Box sx={{ flexGrow: 1 }} />

                            <Box gap={1} sx={{ alignItems: 'center', display: 'flex' }}>
                                <IconButton
                                    color="inherit"
                                    onClick={toggleSearch}
                                >
                                    <SearchIcon />
                                </IconButton>

                                <IconButton
                                    color="inherit"
                                    onClick={() => handleNavigation("/lote")}
                                >
                                    <FaceIcon />
                                </IconButton>
                            </Box>
                        </>
                    )}
                </Toolbar>
            </AppBar>
        </>
    );
};

export default Navbar;